"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.find");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'postDetailNew',
  props: {
    post: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      previewVisible: false,
      previewList: [],
      previewIndex: 0,
      imgList: [],
      orderImgList: []
    };
  },
  computed: {
    statusText: function statusText() {
      var s = this.post.postStatus ? this.post.postStatus : '';
      var map = {
        1: '待审核',
        2: '系统审核通过',
        3: '系统审核不通过',
        4: '审核通过不发奖励',
        5: '人工审核不通过',
        6: '人工审核通过',
        7: '人工审核通过不发奖励',
        8: '已发奖励',
        9: '优质帖待审核',
        10: '优质帖审核通过',
        11: '优质帖审核不通过',
        12: '优质帖奖励已发放'
      };
      return s ? map[s] || s : '-';
    },
    questionsAnswers: function questionsAnswers() {
      var q = this.post.questionsAnswers;
      if (!q) return null;
      var list = JSON.parse(q);
      var orderImg = list.find(function (item) {
        return item.question === '上传订单截图';
      });
      if (orderImg) {
        this.orderImgList = orderImg.answer.split(',').filter(Boolean);
      }
      var filteredList = list.filter(function (item) {
        return item.question !== '上传订单截图';
      });
      return filteredList;
      // try {
      //   const obj = typeof q === 'object' ? q : JSON.parse(q)
      //   return JSON.stringify(obj, null, 2)
      // } catch (e) {
      //   return q
      // }
    },
    postContentHtml: function postContentHtml() {
      var text = this.post.postContent || '';
      return this.linkify(text);
    }
  },
  watch: {
    post: {
      immediate: true,
      handler: function handler() {
        this.updateImages();
      }
    },
    previewVisible: function previewVisible(val) {
      if (val) {
        document.addEventListener('click', this.handleDocClick, true);
      } else {
        document.removeEventListener('click', this.handleDocClick, true);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleDocClick, true);
  },
  methods: {
    // 文档级点击处理：若点击发生在对话框外部，则关闭预览
    handleDocClick: function handleDocClick(e) {
      var dlg = this.$refs.previewDialog && this.$refs.previewDialog.$el;
      if (!dlg) return;
      if (!dlg.contains(e.target)) {
        this.previewVisible = false;
      }
    },
    updateImages: function updateImages() {
      var imgs = this.post.imageUrls || this.post.image_urls || '';
      if (!imgs) {
        this.imgList = [];
      } else if (typeof imgs === 'string') {
        this.imgList = imgs.split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean);
      } else if (Array.isArray(imgs)) {
        this.imgList = imgs;
      } else {
        this.imgList = [];
      }
    },
    previewImg: function previewImg(idx) {
      this.previewIndex = 0;
      this.previewList = this.imgList;
      this.previewIndex = idx;
      this.previewVisible = true;
    },
    prevImg: function prevImg() {
      if (this.previewIndex > 0) this.previewIndex--;
    },
    nextImg: function nextImg() {
      if (this.previewIndex < this.previewList.length - 1) this.previewIndex++;
    },
    previewOrderImg: function previewOrderImg(idx) {
      this.previewIndex = 0;
      this.previewList = this.orderImgList;
      this.previewIndex = idx;
      this.previewVisible = true;
    },
    escapeHtml: function escapeHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    escapeAttr: function escapeAttr(str) {
      return String(str).replace(/"/g, '&quot;');
    },
    linkify: function linkify(text) {
      if (!text) return '';
      var urlRegex = /((https?:\/\/|ftp:\/\/)[^\s]+)|(www\.[^\s]+)/gi;
      var result = '';
      var lastIndex = 0;
      var match;
      while ((match = urlRegex.exec(text)) !== null) {
        var url = match[0];
        var idx = match.index;
        result += this.escapeHtml(text.slice(lastIndex, idx));
        var href = url;
        if (!/^(https?:\/\/|ftp:\/\/)/i.test(href)) href = 'http://' + href;
        // apply inline color style to ensure it affects v-html content
        result += "<a href=\"".concat(this.escapeAttr(encodeURI(href)), "\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color: #409EFF;\">").concat(this.escapeHtml(url), "</a>");
        lastIndex = idx + url.length;
      }
      result += this.escapeHtml(text.slice(lastIndex));
      return result;
    },
    formatJson: function formatJson(v) {
      try {
        var obj = (0, _typeof2.default)(v) === 'object' ? v : JSON.parse(v);
        return JSON.stringify(obj, null, 2);
      } catch (e) {
        return v;
      }
    }
  }
};